module.exports = "<input type=text class=\"js-input bubbles__input\" autocomplete=off>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/membersBubble/templates/input.hbs
// module id = 669
// module chunks = 0